import { ChildDaycareWithParents, ChildParent, ChildWithParents } from '@/types/Child'
import { SelectOption } from '@/types/Select'

export function toChildSelectOption(
    child: ChildWithParents,
    daycareId: number,
    isRpeOrLaep: boolean
): SelectOption<number> {
    const childDaycare: ChildDaycareWithParents | undefined = child.daycares.find(
        (daycare) => daycare.daycareId === daycareId
    )
    const complement: string | undefined = childDaycare?.complement
    const parentNanny: ChildParent | undefined = childDaycare?.parents.find((parent) => parent.isNanny)

    return {
        name:
            (isRpeOrLaep && parentNanny ? parentNanny.lastname + ' ' + parentNanny.firstname + ' - ' : '') +
            child.firstname +
            (complement ? ' - ' + complement : ''),
        value: child.id
    }
}
